import { Account } from '../../../types/management-auth';
import { SwishConnectionCallback } from '../../../types/management-auth/generated';

export enum ActionTypes {
    OpenSwishCallbackModal = '[settings/paymentConnections/swishCallback] OPEN_SWISH_CALLBACK_MODAL',
    InitiateSwishCallback = '[settings/paymentConnections/swishCallback] INITIATE_SWISH_CALLBACK_CONNECTION',
    OpenSwishCallbackForm = '[settings/paymentConnections/swishCallback] OPEN_SWISH_CALLBACK_FORM',
    CloseSwishCallbackModal = '[settings/paymentConnections/swishCallback] CLOSE_SWISH_CALLBACK_MODAL',
    CallbackError = '[settings/paymentConnections/swishCallback] SWISH_CALLBACK_API_ERROR',
    CompleteSwishConnection = '[settings/paymentConnections/swishCallback] COMPLETE_SWISH_CONNECTION',
    FetchCompleteSwishConnectionResponse = '[settings/paymentConnections/swishCallback] COMPLETE_SWISH_CONNECTION_RESPONSE',
}

export interface OpenSwishCallbackModal {
    type: ActionTypes.OpenSwishCallbackModal;
    payload: {
        accountId: string;
        account: Account;
    };
}

export function openSwishCallbackModal(accountId: string, account: Account): OpenSwishCallbackModal {
    return {
        type: ActionTypes.OpenSwishCallbackModal,
        payload: {
            accountId,
            account,
        },
    };
}

export interface OpenSwishCallbackForm {
    type: ActionTypes.OpenSwishCallbackForm;
    payload: {};
}

export interface CloseSwishCallbackModal {
    type: ActionTypes.CloseSwishCallbackModal;
    payload: {};
}

export function closeSwishCallbackModal(): CloseSwishCallbackModal {
    return {
        type: ActionTypes.CloseSwishCallbackModal,
        payload: {},
    };
}

export interface InitiateSwishCallback {
    type: ActionTypes.InitiateSwishCallback;
    payload: {
        accountId: string;
    };
}

export interface CompleteSwishConnection {
    type: ActionTypes.CompleteSwishConnection;
    payload: {
        accountId: string;
        userId: string;
        data: SwishConnectionCallback;
    };
}

export function completeSwishConnection(
    accountId: string,
    userId: string,
    data: SwishConnectionCallback
): CompleteSwishConnection {
    return {
        type: ActionTypes.CompleteSwishConnection,
        payload: {
            accountId,
            userId,
            data,
        },
    };
}

export interface FetchCompleteSwishConnectionResponse {
    type: ActionTypes.FetchCompleteSwishConnectionResponse;
    payload: {
        response: {};
    };
    meta: {
        cause: CompleteSwishConnection;
    };
}

export interface SwishApiError {
    type: ActionTypes.CallbackError;
    payload: {};
}

export type Actions =
    | OpenSwishCallbackModal
    | CloseSwishCallbackModal
    | InitiateSwishCallback
    | FetchCompleteSwishConnectionResponse
    | OpenSwishCallbackForm
    | SwishApiError;
